"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleImageProxy = handleImageProxy;
exports.handleInlineImage = handleInlineImage;
exports.handleDataURISchemeImage = handleDataURISchemeImage;
exports.isHTMLContainExternalImages = isHTMLContainExternalImages;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _index = require("./index");

var _utils = require("../styles/utils");

var _constants = require("./constants");

var _autolinker = require("./autolinker");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BACKGROUND_IMAGE_REGEXP = /url\(["']?([^"']*)["']?\)/;

function handleImageProxy(node) {
  if (node.style.backgroundImage && node.style.backgroundImage.match(BACKGROUND_IMAGE_REGEXP)) {
    var match = node.style.backgroundImage.match(BACKGROUND_IMAGE_REGEXP);

    try {
      var url = (0, _autolinker.formatUrl)(match[1]);

      if (url.startsWith('//')) {
        node.style.backgroundImage = "url(\"".concat(url, "\")");
        return;
      }

      node.setAttribute('data-background-image-url', url);
      node.style.backgroundImage = '';
    } catch (e) {
      node.style.backgroundImage = '';
    }
  }

  if (node.nodeName === 'IMG' && node.hasAttribute('src') && !node.getAttribute('src').startsWith('cid:')) {
    var src = node.getAttribute('src');

    try {
      var _url = (0, _autolinker.formatUrl)(src);

      if (_url.startsWith('//')) {
        node.setAttribute('src', _url);
        return;
      }

      node.setAttribute('data-src', _url);
      node.removeAttribute('src');
    } catch (e) {
      node.removeAttribute('src');
    }
  }
}

function handleInlineImage(node) {
  if (node.nodeName === 'IMG' && node.hasAttribute('src') && node.getAttribute('src').startsWith('cid:')) {
    var src = node.getAttribute('src');
    node.setAttribute('cid', src.slice(4));
    node.removeAttribute('src');
  }
}

function handleDataURISchemeImage(node) {
  if (node.nodeName === 'IMG' && node.hasAttribute('src') && node.getAttribute('src').startsWith('data:')) {
    node.removeAttribute('src');
  }
}

function addRemoveDataURISchemeImageSourceHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    handleDataURISchemeImage(node);
  });
}

function addHandleImageProxyHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    handleImageProxy(node);
  });
}

function addSanitizeCssHook() {
  var removeInvalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  // Validate regular CSS properties
  function formatStyle(key, value) {
    if (key.startsWith('padding') || key.startsWith('margin')) {
      var intValue = parseInt(value);
      return isNaN(intValue) || intValue >= 0 ? value : 0;
    }

    return value;
  }
  /**
   *  Take CSS property-value pairs and validate against allow-list,
   *  then add the styles to an array of property-value pairs
   */


  function validateStyles(styles) {
    var properties = (0, _toConsumableArray2["default"])(styles);
    var validProperties = properties.filter(function (key) {
      if (_constants.ALLOWED_CSS_PROPERTIES.includes(key)) {
        if (removeInvalid) {
          if (_constants.COMPOSE_INVALID_STYLE.includes(key)) return false;
          if (key === 'white-space' && !styles[key].startsWith('pre')) return false;
        }

        return true;
      }

      return false;
    });
    var invalidProperties = properties.filter(function (key) {
      return !validProperties.includes(key);
    });
    validProperties.forEach(function (key) {
      return styles.setProperty(key, formatStyle(key, styles[key]), styles.getPropertyPriority(key));
    });
    invalidProperties.forEach(function (key) {
      return styles.removeProperty(key);
    });
  }
  /**
   * Take CSS rules and analyze them, create string wrapper to
   * apply them to the DOM later on. Note that only selector rules
   * are supported right now
   */


  function validateCSSRules(cssRules) {
    var output = [];
    var total = cssRules.length;

    for (var index = 0; index < total; index++) {
      var rule = cssRules[index]; // check for rules with selector

      if (rule.type === CSSRule.STYLE_RULE && rule.selectorText && rule.style) {
        validateStyles(rule.style);
        output.push("".concat(rule.selectorText, " { ").concat(rule.style.cssText, " }"));
      } else if (rule.type === CSSRule.MEDIA_RULE) {
        output.push("@media ".concat(rule.conditionText, " { ").concat(validateCSSRules(rule.cssRules), " }"));
      }
    }

    return output.join('');
  } // Add a hook to enforce CSS element sanitization


  _dompurify["default"].addHook('uponSanitizeElement', function (node, data) {
    if (data.tagName === 'style' && node.sheet) {
      node.textContent = validateCSSRules(node.sheet.cssRules);
    }
  }); // Add a hook to enforce CSS attribute sanitization


  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    // Nasty hack to fix baseURI + CSS problems in Chrome
    if (!node.ownerDocument.baseURI) {
      var base = document.createElement('base');
      base.href = document.baseURI;
      node.ownerDocument.head.appendChild(base);
    } // Check all style attribute values and validate them


    if (node.hasAttribute('style')) {
      validateStyles(node.style);
    }
  });
}

function addHandleLinkHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    if (node.nodeName === 'A') {
      var href = node.hasAttribute('href') ? node.getAttribute('href').trim() : '';

      try {
        var url = (0, _autolinker.formatUrl)(href);
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('href', url);
      } catch (e) {
        node.removeAttribute('href');
      }
    }
  });
}

var LARGE_ATTACHMENT_SELECTOR = 'body > table.webmail_upload_view';

function addRemoveLargeAttachmentTemplateHook(node) {
  _dompurify["default"].addHook('beforeSanitizeAttributes', function (node) {
    if (node.matches && node.matches(LARGE_ATTACHMENT_SELECTOR)) {
      node.remove();
    }
  });
}

function addHandleInlineImageHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    handleInlineImage(node);
  });
}

function addRemoveRemoteImageSourceHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    if (node.nodeName === 'IMG' && node.hasAttribute('src')) {
      var src = node.getAttribute('src');

      if (!src.startsWith('cid:')) {
        node.removeAttribute('src');
      }
    }

    if (node.style.backgroundImage) {
      node.style.backgroundImage = 'url("")';
    }
  });
}

function addRemoveInlineImageSourceHook() {
  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    if (node.nodeName === 'IMG' && node.hasAttribute('src')) {
      var src = node.getAttribute('src');

      if (src.startsWith('cid:')) {
        node.removeAttribute('src');
      }
    }
  });
}

function addDarkModeHook(_ref) {
  var baseColorScheme = _ref.baseColorScheme;

  _dompurify["default"].addHook('uponSanitizeElement', function (node, data) {
    if (data.tagName === 'style' && node.sheet) {
      (0, _utils.applyDarkModeToStyle)(node, {
        baseColorScheme: baseColorScheme
      });
    }
  });

  _dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
    if (node.hasAttribute('style') || node.hasAttribute('bgColor') || node.hasAttribute('color')) {
      (0, _utils.applyDarkModeToNode)(node, {
        baseColorScheme: baseColorScheme
      });
    }
  });
}

var _default = function _default(html, options) {
  options = _objectSpread(_objectSpread({
    removeLargeAttachment: false,
    removeInlineImageSource: false,
    removeRemoteImageSource: false,
    removeDataURISchemeImageSource: true,
    removeComposeInvalidStyle: false,
    handleImage: true,
    handleLink: true,
    ALLOWED_TAGS: _constants.ALLOWED_TAGS,
    ALLOWED_ATTR: _constants.ALLOWED_ATTR
  }, options), {}, {
    WHOLE_DOCUMENT: true,
    RETURN_DOM: true
  });
  var _options = options,
      darkMode = _options.darkMode,
      removeLargeAttachment = _options.removeLargeAttachment,
      removeRemoteImageSource = _options.removeRemoteImageSource,
      removeInlineImageSource = _options.removeInlineImageSource,
      handleImage = _options.handleImage,
      handleLink = _options.handleLink,
      handleLinkText = _options.handleLinkText,
      removeComposeInvalidStyle = _options.removeComposeInvalidStyle,
      removeDataURISchemeImageSource = _options.removeDataURISchemeImageSource,
      rest = (0, _objectWithoutProperties2["default"])(_options, ["darkMode", "removeLargeAttachment", "removeRemoteImageSource", "removeInlineImageSource", "handleImage", "handleLink", "handleLinkText", "removeComposeInvalidStyle", "removeDataURISchemeImageSource"]);

  _dompurify["default"].removeAllHooks();

  if (darkMode && darkMode.enable) {
    addDarkModeHook({
      baseColorScheme: {
        color: darkMode.color,
        backgroundColor: darkMode.backgroundColor
      }
    });
  }

  addSanitizeCssHook(removeComposeInvalidStyle);

  if (handleLink) {
    addHandleLinkHook();
  }

  removeLargeAttachment && addRemoveLargeAttachmentTemplateHook();
  removeDataURISchemeImageSource && addRemoveDataURISchemeImageSourceHook();

  if (handleImage) {
    if (removeRemoteImageSource) {
      addRemoveRemoteImageSourceHook();
    } else {
      addHandleImageProxyHook();
    }

    if (removeInlineImageSource) {
      addRemoveInlineImageSourceHook();
    } else {
      addHandleInlineImageHook();
    }
  }

  return _dompurify["default"].sanitize(html, rest).ownerDocument;
};

exports["default"] = _default;

function isHTMLContainExternalImages(html) {
  var removeLargeAttachment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html'); //the large attachment html section maybe contain external image.

  if (removeLargeAttachment) {
    var node = doc.querySelector(LARGE_ATTACHMENT_SELECTOR);
    node && node.remove();
  }

  return !!doc.querySelector('img[src^="http"]');
}
//# sourceMappingURL=DOMSanitize.js.map